"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlreadyExistingDbPort = void 0;
const getAlreadyExistingDbPort = () => {
    const envVarIsPresent = typeof process.env.ALREADY_EXISTING_TEST_DB_PORT === "string";
    if (!envVarIsPresent) {
        return null;
    }
    const rawValue = process.env.ALREADY_EXISTING_TEST_DB_PORT;
    if (!rawValue) {
        return null;
    }
    const port = Number(process.env.ALREADY_EXISTING_TEST_DB_PORT);
    if (isNaN(port)) {
        throw new Error("ALREADY_EXISTING_TEST_DB_PORT is not a number");
    }
    return port;
};
exports.getAlreadyExistingDbPort = getAlreadyExistingDbPort;
//# sourceMappingURL=container.js.map